import React ,{useEffect,useState}from 'react'
import {faXmark, faSliders,} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Respbn(props) {
    const [scr,setscr]=useState(window.innerWidth)
    const [dow,setdow]=useState(true)
    const [icon,seticon]=useState(faSliders)
  
    useEffect(()=>{
      if(dow==true){
        setTimeout(() => {
          document.getElementById('Lmenu2id').style.display='flex' 
        }, 0);
        
        seticon(faXmark)
      }
      else{
        document.getElementById('Lmenu2id').style.display='none' 
        seticon(faSliders)
      }
    },[dow])
    
    
   const dw=()=>{
    setTimeout(() => {
        setdow(true)
    }, 0);
   }
    useEffect(() => {
        const handleResize = () => {
            setscr(window.innerWidth);
          };
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []);

      
  return (
    <>
    {scr<769? <div className='rmicons flex-center' id='rmitems4' onClick={()=>setdow(!dow)}><FontAwesomeIcon icon={icon} /></div>:dw()}
    </>
    
   
  )
}
